/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-undef */
import { useState, useEffect, useMemo } from 'react';
 // eslint-disable-line no-use-before-define
import { MaterialReactTable } from 'material-react-table';  // eslint-disable-line no-use-before-define
import {Search} from 'lucide-react';
// ----------------------------------------------------------------------
export default function AllApplications({isLoadingUsers,tableData,getSearchFilterData,setSorting,sorting}) {
  const [user] = useState([]);
  const [search,setSearch] = useState('');


  const currentYear = new Date().getFullYear();

  
  const columns = useMemo(
    () => [
     
      {
        accessorKey: 'year',
        header: 'Year',
        size: 8,
        editVariant:"select",
        editSelectOptions:Array.from({ length: currentYear - 1939 }, (_, index) => ({
          label: `${currentYear - index}`,
          value: `${currentYear - index}`,
        }))
      },
      {
        accessorKey: 'quarter',
        header: 'Quarter',
        size: 5,
      },
      {
        accessorKey: 'program_stream',
        header: 'Program Stream',
        size: 50,
      },
      {
        accessorKey: 'province',
        header: 'Province',
        size: 50,
      },
      {
        accessorKey: 'city',
        header: 'City',
        size: 150,
      },
      {
        accessorKey: 'postal_code',
        header: 'Postal Code',
        size: 20,
      },
      {
        accessorKey: 'employer',
        header: 'Employer',
        size: 200,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 20,
      
      },
      {
        accessorKey: 'lmia',
        header: 'LMIA',
        size: 50,
        editVariant: 'select',
        editSelectOptions:[
          {
            label:"Approved",
            value:"1",
          },
          {
            label:"Denied",
            value:"0",
          }
        ]
      },
      {
        accessorKey: 'positions',
        header: 'Positions',
        size: 10,
      },
     
    {
      accessorKey: 'noc_code',
      header: 'NOC Code',
      size: 10,
     
    },
    {
      accessorKey: 'noc_version',
      header: 'NOC Version',
      size: 10,
    
    },
   
      
      {
        accessorKey: 'description',
        header: 'Description',
        size: 250,
      },
      
      
      
     
     
      // {
      //   accessorKey: 'user_id',
      //   header: 'User ',
      //   size: 50,
      //   enableEditing: false,
      // },
     
    
      
      
     
    ],[currentYear]
   
  );
const handleSubmit=(e)=>{
  e.preventDefault();
  getSearchFilterData(search,1)
}




  useEffect(() => {
    if (user?.length) {
      setTableData(user);
    }
  }, [user]);

  return (
    < >
      <div className="container px-2 md:px-10 pt-5 mx-auto">
        {/* <HeaderBreadcrumbs heading="User" links={[{ name: '', href: '' }]} /> */}

        <MaterialReactTable
          columns={columns}
          data={tableData}
      
          getRowId={(row) => row.id}
       
       
          // positionActionsColumn="last"
          state={{
            isLoading: isLoadingUsers,
            sorting:sorting
           
          }}
          enableGlobalFilter={false}
          enablePagination={false}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          enableColumnFilters={false}
          enableColumnActions={false}
         enableColumnOrdering={false}
         manualSorting={true}
         manualPagination={true}
        //  enableSorting={false}
        onSortingChange={setSorting}
        muiPaginationProps={{
          rowsPerPageOptions: [10, 25, 100],
          hideNextButton:true,
        
          
        }}
        

          renderTopToolbarCustomActions={({ table }) => {
          
            return (
            <>
            <form onSubmit={handleSubmit} className="relative border border-solid border-gray-400 ">
            <input
      type="text"
      name="search"
      onChange={(e)=>setSearch(e.target.value)}
      value={search}
      className="py-1 px-3 border  border-gray-400  bg-white w-full border-none  placeholder:text-[#494949] focus:text-[#494949] focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima pr-8"
      placeholder="Search ..."

    />
    <button type='submit' className=' z-40 absolute right-0 top-1 text-gray-400 cursor-pointer'>
    <Search/>
    </button>
 
            </form>
            </>
            );
          }}
        />
        <div className="license-link">
          <a href="https://open.canada.ca/en/open-government-licence-canada" target="_blank" className="text-primary hover:underline">Open Government Licence – Canada.</a>
        </div>
        {/* <AddUser open={open} setOpen={setOpen} /> */}
      </div>
    </>
  );
}
